import React, { useEffect } from 'react';
import { useWidgetModals, WidgetModalController } from '@features';
import { handleWidgetActionFromTwig } from '@entities/widget-card/lib';



type WidgetActionHostProps = {
    elementIdentifier: string;
    triggerSelector: string;
};

export const WidgetActionHost = ({
    elementIdentifier,
    triggerSelector,
}: WidgetActionHostProps) => {
    const { openDetails, openOnlyAdmin } = useWidgetModals();

    useEffect(() => {
        if (!elementIdentifier || !triggerSelector) {
            return undefined;
        }

        const handleClick = (event: Event) => {
            const target = event.target;

            if (!(target instanceof Element)) {
                return;
            }

            const trigger = target.closest(triggerSelector);

            if (!trigger) {
                return;
            }

            event.preventDefault();

            handleWidgetActionFromTwig({
                elementIdentifier,
                onWidgetAvailable: () => {},
                onOpenDetails: openDetails,
                onOpenOnlyAdmin: openOnlyAdmin,
            });
        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [elementIdentifier, openDetails, openOnlyAdmin, triggerSelector]);

    return <WidgetModalController />;
};
